export default __webpack_public_path__ + "static/media/driveThru.88df113a.svg";